import { Routes } from '@angular/router';
import { ORDERING_ROUTES } from './features/ordering/ordering.routes';

/**
 * The storefront owns the whole origin here, so the portal's own route table IS the app's.
 * (In the product website these same routes were mounted lazily under /ordering.) Keeping them in
 * features/ordering/ordering.routes.ts means the tree stays diff-compatible with that repo.
 */
export const routes: Routes = [
  ...ORDERING_ROUTES,
  // Unknown URL → the layout's own empty-path redirect takes it to the landing page. Without this a
  // typo'd or stale deep link would render a blank page.
  { path: '**', redirectTo: '' },
];
